export const LOADING = {
	type: ''
}

export const MESSAGE = {
	type: '',
	message: '',
	open: false,
	time: 5000,
}

